/**
 * Преобразовать дату к формату времени "ЧЧ:ММ"
 * Если строковая дата не валидна/не корректна, то возвращается пустая строка
 *
 * @param dateString - Дата.
 * @returns Строка времени или пустая строка.
 */
export const toTime = (dateString: string): string => {
  if (Number.isNaN(Date.parse(dateString))) {
    return '';
  }

  const date = new Date(dateString);

  return `${date.getHours().toString().padStart(2, '0')}:${date
    .getMinutes()
    .toString()
    .padStart(2, '0')}`;
};
